<script>
import { apiData } from "@/api";
import DatePicker from "../../plugins/DatePicker/DatePicker.vue";
import WindBarb from "../../plugins/map2d/WindBarb";
import { Vector as VectorLayer } from "ol/layer";
import { Vector, Vector as VectorSource } from "ol/source";
import Feature from "ol/Feature";
import { Circle, Icon, Style, Stroke, Text, Fill } from "ol/style";
import { Point } from "ol/geom";

export default {
  props: ["params"],
  data() {
    return {
      pointLayer: null,
      pointSource: null,
      checkLiveEle: ["t"],
      LiveEles: [
        {
          value: "t",
          label: "温度(℃)",
        },
        {
          value: "wd2dd",
          label: "平均风(m/s)",
        },
        {
          value: "wd3smaxdd",
          label: "瞬时风(m/s)",
        },
        {
          value: "p",
          label: "气压(hPa)",
        },
        {
          value: "rh",
          label: "相对湿度(%)",
        },
        {
          value: "r01h",
          label: "1小时降水(mm)",
        },
        {
          value: "r03h",
          label: "3小时降水(mm)",
        },
        {
          value: "r06h",
          label: "6小时降水(mm)",
        },
        {
          value: "r24h",
          label: "24小时降水(mm)",
        },
      ],
      type: "",
      layer: "",
      stime: this.$moment().subtract(1, "month").format("YYYY-MM-DD HH:mm:00"),
      etime: this.$moment().format("YYYY-MM-DD HH:mm:00"),
      ddatetime: "",
      pointData: [],
    };
  },
  methods: {
    async init() {
      const company = this.$route.params.company;
      const { unit } = JSON.parse(localStorage.getItem(company));
      try {
        const res = await apiData.queryPointLiveData(unit.id, this.ddatetime);
        if (res.status === 200 && res.data.length > 0) {
          this.pointData = res.data;
          this.addPointLayer(this.checkLiveEle);
        } else {
          this.$message.error("当前时次无数据");
        }
      } catch (error) { }
    },
    addPointLayer(showElements) {
      console.log("this.params", this.params);

      if (!this.pointLayer) {
        this.pointSource = new VectorSource();
        this.pointLayer = new VectorLayer({
          zIndex: 99999,
          source: this.pointSource,
        });
        this.params.map2d.map.addLayer(this.pointLayer);
      }
      const features = [];
      this.pointSource.clear();
      showElements.forEach((type) => {
        this.pointData.forEach((item) => {
          const positon = [item.lon, item.lat];
          const feature = new Feature({
            geometry: new Point(positon),
            liveData: item,
          });
          let text = item[type] + "";
          if (
            ["-999.9", "9999", "undifined", "null", "undefined"].includes(text)
          ) {
            text = "";
          }

          if (!["wd2dd", "wd3smaxdd"].includes(type)) {
            const style = new Style({
              image: new Circle({
                radius: 2,
                fill: new Fill({
                  color: "#000",
                }),
              }),
              text: new Text({
                text: text,
                font: "0.9vw  sans-serif",
                fill: new Fill({
                  color: "black",
                }),
                offsetX:
                  type === "t"
                    ? -30
                    : type === "rh"
                      ? -30
                      : ["r01h", "r03h", "r06h", "r24h"].includes(type)
                        ? -30
                        : type === "p"
                          ? 45
                          : 33,
                offsetY:
                  type === "t"
                    ? -15
                    : type === "rh"
                      ? 0
                      : ["r01h", "r03h", "r06h", "r24h"].includes(type)
                        ? 15
                        : type === "p"
                          ? 0
                          : -15,
              }),
            });
            feature.setStyle(style);
          } else {
            let rotation = 0;
            rotation = (parseFloat(item[type]) * Math.PI) / 180;
            if (!this.windBarb) {
              this.windBarb = new WindBarb(10);
            }
            const img = this.windBarb.getIconOfCanvas(3, "#00646477");
            const style = new Style({
              image: new Icon({
                img: img,
                imgSize: [13, 26],
                anchor: type === "wd2dd" ? [-20, 1] : [-30, 1],
                anchorXUnits: "pixels",
                rotation: rotation,
              }),
            });
            feature.setStyle(style);
            feature.set("wind", true);
          }

          features.push(feature);
        });
      });
      this.pointSource.addFeatures(features);
      this.pointSource.changed();
    },

    async callbackLive(time) {
      this.ddatetime = this.$moment(time).format("YYYY-MM-DD HH:mm:00");
      await this.init();
    },
    hanldLiveChange() {
      if (this.checkLiveEle.length > 0) {
        this.addPointLayer(this.checkLiveEle);
      } else {
        this.pointSource.getFeatures().forEach((feature) => {
          const style = new Style({
            image: new Circle({
              radius: 2,
              fill: new Fill({
                color: "#000", // 使用灰色或其他颜色表示未选中状态
              }),
            }),
          });
          feature.setStyle(style);
        });
      }
    },
  },
  mounted() { },
  components: {
    DatePicker,
  },
};
</script>
<template>
  <div class="content-item" v-show="params.flag">
    <div class="content-item-title">实况观测</div>
    <date-picker @callback="callbackLive" :interval="5" :delayTime="15" :DatetimeRange="[stime, etime]"></date-picker>
    <el-checkbox-group v-model="checkLiveEle" @change="hanldLiveChange">
      <el-checkbox v-for="item in LiveEles" :key="item.value" :label="item.value">{{ item.label }}</el-checkbox>
    </el-checkbox-group>
  </div>
</template>

<style lang="less" scoped>
.content-item {
  display: flex;
  flex-direction: column;
  gap: 1.1111vh;

  .content-item-title {
    padding: 0 0.63vw;
    height: 3.4259vh;
    display: flex;
    align-items: center;
    background: #def0ff;
    border-radius: 0.21vw;
    font-weight: 600;
    font-size: 0.83vw;
    color: #333333;
  }

  /deep/.DatePicker {
    color: #0a0a0a;

    .picker-box-inner {
      background: rgba(247, 250, 255, 0.49);
      box-shadow: 0px 4px 8px 0px rgba(192, 220, 244, 0.43);
      border-radius: 4px;
      border: 1px solid #e3ebed;

      .date-picker {
        width: 5.43vw;
      }

      .select-box {
        width: 1.5vw;
      }

      .el-input__inner {
        color: #0a0a0a;
      }

      .el-input__prefix {
        color: #9b9c9f;
      }

      .icon-caret-top {
        border-bottom: 0.5em solid #9b9c9f;
      }

      .icon-caret-bottom {
        border-top: 0.5em solid #9b9c9f;
      }
    }
  }

  /deep/.el-checkbox-group {
    display: flex;
    flex-wrap: wrap;
    gap: 1.8519vh 0;

    .el-checkbox {
      margin-right: 0;
      width: 50%;
    }

    .el-checkbox__inner {
      width: 0.83vw;
      height: 0.83vw;
      border-radius: 3px;
      border: 1px solid #c6cdcf;
    }

    .el-checkbox__label {
      font-size: 0.73vw;
      color: #333333;
    }
  }
}
</style>
